export const UI_ELEMENT_TRANSLATION_TITLE = "UI Element Translations";

export const UI_ELEMENT_FIELD_GUIDE_INTRO =
  "The fixed UI strings the app shows in the learner’s target language. The list is seeded for every language; " +
  "only each translation is editable.";

export const UI_ELEMENT_FIELD_GUIDE = [
  {
    label: "“Hello” Translation",
    description: "Displayed on the main dashboard upon entry as the initial greeting.",
  },
  {
    label: "“Very Good” Translation",
    description: "Used on the post-conversation feedback page after completing a session.",
  },
  {
    label: "“Female / Male” Translation",
    description: "Used during onboarding for users to select their preferred gender before starting AI conversations.",
  },
];

export const UI_ELEMENT_TRANSLATION_REQUIRED = "Translation is required.";
